import {useFonts} from 'expo-font'

/*
 * IMPORTANT: This is unused. Expo statically extracts these fonts.
 *
 * All used fonts MUST be configured here. Unused fonts can be commented out.
 *
 * This is used for both web fonts and native fonts.
 */
export function DO_NOT_USE() {
  return useFonts({
    InterVariable: require('../../../assets/fonts/inter/InterVariable.woff2'),
    'InterVariable-Italic': require('../../../assets/fonts/inter/InterVariable-Italic.woff2'),
    'ScheherazadeNew-Regular': require('../../../assets/fonts/scheherazade-new/ScheherazadeNew-Regular.ttf'),
    'ScheherazadeNew-Bold': require('../../../assets/fonts/scheherazade-new/ScheherazadeNew-Bold.ttf'),
    'Fraunces-SemiBold': require('../../../assets/fonts/fraunces/Fraunces-SemiBold.ttf'),
    'Archivo-SemiBold': require('../../../assets/fonts/archivo/Archivo-SemiBold.ttf'),
    'Vollkorn-Regular': require('../../../assets/fonts/vollkorn/Vollkorn-Regular.ttf'),
  })
}
